import { createContext, useContext } from 'react'

/**
 * True inside the persistent Arc shell (router-level chrome). Layout reads it
 * to skip rendering its own top bar/sidebar — the shell already did — so
 * pages keep calling <Layout> untouched while the chrome survives navigation.
 */
export const ArcShellContext = createContext(false)

export const useIsInsideArcShell = () => useContext(ArcShellContext)
